import { ID, TaskLinkFields } from '@griply/types';

import { taskGoalIds, taskLifeAreaIds } from './task-link-ids';

export type TaskLinkFilter = {
  goals?: ID[];
  lifeAreas?: ID[];
};

// Goals and life areas are one union: a task matches when any of its links is picked.
export const matchesTaskLinkFilter = (
  item: TaskLinkFields,
  { goals, lifeAreas }: TaskLinkFilter,
): boolean => {
  const linkedItemIds = [...(goals ?? []), ...(lifeAreas ?? [])];
  if (!linkedItemIds.length) {
    return true;
  }

  return [...taskGoalIds(item), ...taskLifeAreaIds(item)].some((id) =>
    linkedItemIds.includes(id),
  );
};
